import moment from 'moment-timezone';

export function validateEmail(email) {
    if (email === null || email === '') {
        // error: empty field
        return false;
    } else if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        // valid.
        if (email.slice(-4) === '.con') {
            return false;
        }
        return true;
    } else {
        // error: invalid format
        return false;
    }
}

export function validateInt(num) {
    if (num && !isNaN(num)) {
        return true;
    } else {
        return false;
    }
}

export function validateString(str) {
    if (str) {
        return true;
    } else {
        return false;
    }
}

export function validatePostalCode(postalCode, region) {
    if (region === 'CA' || region === 'Canada') {
        // Remove spaces for validation
        const cleaned = postalCode.replace(/\s/g, '');
        if (
            cleaned.match(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i) &&
            cleaned.length === 6
        ) {
            return true;
        }
    } else if (region === 'US' || region === 'United States') {
        if (postalCode.match('^\\d{5}(-{0,1}\\d{4})?$')) {
            return true;
        }
    }
    return false;
}

export function isRichTextEmpty(htmlContent) {
    if (!htmlContent || typeof htmlContent !== 'string') {
        return true;
    }
    
    const trimmed = htmlContent.trim();
    
    if (trimmed === '' || trimmed === '<p></p>' || trimmed === '<p><br></p>') {
        return true;
    }
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = trimmed;
    
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    
    return textContent.trim() === '';
}

export function getMomentFromDateAndTime(date, time) {
    const d = moment(new Date(date));
    const t = moment(new Date(time));

    const combo = moment()
        .set('year', d.get('year'))
        .set('month', d.get('month'))
        .set('date', d.get('date'))
        .set('hour', t.get('hour'))
        .set('minute', t.get('minute'));

    return combo;
}

export function validateURL(url) {
    const _url = url.trim();
    return _url.startsWith('http://') || _url.startsWith('https://');
}

// Stricter than validateURL: a http(s) prefix alone is not enough (e.g. "https://").
function isValidHttpUrl(value) {
    try {
        const parsed = new URL(value);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
}

// Robin webhook setup accepts either a full delivery URL or a bare agent ID.
// Agent IDs must not contain "/" — the API prefixes them with Robin's base URL.
export function validateRobinUrlOrId(value) {
    const trimmed = value.trim();
    if (!trimmed) return false;
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        return isValidHttpUrl(trimmed);
    }
    return !trimmed.includes('/');
}

export function validatePhone(phone) {
    return phone.length === 10 || phone.length === 11 || phone.length === 12;
}

export function validateSelect(select) {
    return select !== '';
}
